import type { RootState } from '@core/core/store'

const selectUser = (state: RootState) => state.userInfo.user

export const selectUserId = (state: RootState) => selectUser(state)?.sub

export const selectUserName = (state: RootState) => selectUser(state)?.name

export const selectPreferredName = (state: RootState) => selectUser(state)?.preferred_username

export const selectDisplayName = (state: RootState) =>
  selectPreferredName(state)?.split('.').join('')
